export default __webpack_public_path__ + "static/media/1763.d184251c.png";